const safeDecode = value => {
  if (!value) return value

  const cleaned = value.replace(/%%/g, '%25%')

  try {
    return decodeURIComponent(cleaned)
  } catch (e) {
    console.warn('Failed to decode:', cleaned, e)
    return cleaned
  }
}

export default safeDecode
